export const PROJECT_TYPES = [
  "Vinyl",
  "Laminát",
  "Dřevo",
  "Renovace parket",
  "Nevím, poraďte",
] as const;

export type ProjectType = (typeof PROJECT_TYPES)[number];
